module.exports = __webpack_public_path__ + "img/cptgb-1.5095df63.png";